import ILanguage from '@/assets/lang/ILanguage';

const en: ILanguage = {
  generic: {
    developedBy: 'Developed by',
    loading: 'Loading, please wait',
    anonymousEvaluation: 'Evaluate in anonymity',
    acceptanceContact: 'I agree to be contacted',
    chooseTheChannelToContact: 'Choose the best way for us to contact you',
    whatsapp: 'Whatsapp',
    phone: 'Phone',
    email: 'E-mail',
    like: 'Like',
    back: 'Back',
    skipAnswer: 'Skip this question',
    scoreOption: 'Score {score}',
    noScore: 'No score',
    progress: 'Survey progress',
    paidSurveyFrameTitle: 'Paid surveys',
    dislike: 'Dislike',
    forceAnonymousEvaluation: 'Anonymous Survey',
  },

  preEnrichment: {
    title: 'Satisfaction Survey',
    subtitle: 'Fill in the information below to start the survey:',
    error: 'There was a problem registering, please try again.',
  },

  enrichment: {
    title: 'Enter the information below',
    requiredField: 'Required field',
    invalidDocument: 'Invalid Document',
    invalidEntityDocument: 'Invalid Entity Document',
    invalidDate: 'Invalid Date',
    labelName: 'Full Name',
    PlaceholderName: 'First name Last name',
    labelEmail: 'Email',
    labelGender: 'Gender',
    maleGender: 'Male',
    femaleGender: 'Female',
    otherGender: 'Other',
    zipcode: 'Zip Code',
    state: 'State',
    statePlaceholder: 'SP',
    city: 'City',
    cityPlaceholder: 'São José dos Campos',
    neighbor: 'Neighbor',
    neighborPlaceholder: 'Jardim Veneza',
    address: 'Street',
    addressPlaceholder: 'Rua João das Neves',
    number: 'Number',
    complement: 'Complement',
    labelPhone: 'Phone Number',
    labelBirth: 'Birth',
    labelDocument: 'Document',
    labelEntityDocument: 'Entity Document',
    labelDocumentOrEntityDocument: 'Document or the Entity Document',
    maskDocument: '###-##-####',
    finish: 'FINISH',
    start: 'START',
    skip: 'skip',
    send: 'SEND',
  },

  errorMessages: {
    opsText: 'Oops!',
    unexpectedError: 'Oops! Survey not available at the moment',
    unexpectedErrorDetails: 'Survey not available at the moment',
    missingItem: 'Missed an opinion on an item',
    missingScore: 'Choose a rating from 0 to 10',
    missingScoreCSAT: 'Choose a rating from 1 to 5',
    missingScoreCES: 'Choose a rating from 1 to 7',
    surveyAlreadyDone: 'This survey has already been carried out',
    surveyAlreadyDoneDetails: 'Unfortunately it is not possible to perform this assessment again.',
    surveyNotFound: 'Oops! Rating not found',
    surveyNotFoundDetails:
      'Unfortunately, there was a failure, but be sure to evaluate the next survey. Your opinion is very important to us.',
    surveyExpired: 'The period for performing this assessment has expired',
    surveyExpiredDetails: 'Unfortunately this review is no longer available.',
    surveyInvalidScore: 'Oops! Invalid rating',
    surveyInvalidScoreDetails: 'You entered an invalid rating for this type of survey.',
    surveyInativeJourney: 'Oops! Survey not available at the moment',
    surveyInativeJourneyDetails: 'Survey not available at the moment',
    SURVEY_SUSPENDED: 'Campaign ended',
    SURVEY_SUSPENDEDDetails: "Don't let to rate us in your next experience. Your opinion is very important",
    surveyBlocked: 'Oops! Survey not available at the moment',
    surveyBlockedDetails: 'Survey not available at the moment',
    'Survey blocked': 'Oops! Survey not available at the moment',
    'Survey blockedDetails': 'Survey not available at the moment',
    'survey blocked': 'Oops! Survey not available at the moment',
    'survey blockedDetails': 'Survey not available at the moment',
    'Journey is required for this instance': 'Journey not provided',
    'Journey is required for this instanceDetails': 'Journey is required for this instance',
    'Transaction already rated': 'This survey has already been carried out',
    'Transaction already ratedDetails': 'Unfortunately it is not possible to perform this assessment again.',
  },

  unsubscribe: {
    title: 'Too bad!',
    titleDescription:
      'Our intention was always to offer you the best experience possible. When you unsubscribe, you will no longer receive our customer satisfaction survey from ',
    descriptionAfter: ' will be unsubscribed.',
    error: "It's not possible to unsubcribe the E-Mail",
    thanks: 'Thank you',
    form: {
      question: 'Please, select the reason of your leaving:',
      answer1: "I don't want to tell my oppinion",
      answer2: "I'm receiving too many contacts",
      answer3: "This survey doesn't concern me",
      answer4: 'Other reason',
      send: 'Send',
    },
  },

  selectBelow: 'Select one of the buttons below',
  totallyDisagree: 'Extremely Hard',
  Disagree: 'Very Hard',
  partiallyDisagree: 'Reasonably Difficult',
  Neutral: 'Neutral',
  partiallyAgree: 'Reasonably Easy',
  Agree: 'Very Easy',
  stronglyAgree: 'Extremely Easy',
  howCouldWeImprove: 'How could we improve?',
  leaveYourSuggestionHere: 'Leave your suggestion here.',
  requiredLabel: 'Required',
  isRequiredField: 'It is necessary to fill this field',
  clickOnButton: 'Click on the button',
  skipOrClickOnButton: 'Skip or click the button',
  toNotAnswerQuestion: 'to not answer a question',
};

export default en;
